<template>
    <div class="unread-wrapper" >
        <div class="global">
            <ul class="list" >
                <li v-for="(unRead,index) in data" :key="index" >
                    <img :src="userPic"/>
                    <div class="status" >
                        <h3>{{unRead.name}}</h3>
                        <span>{{unRead.identity}}</span>
                    </div>
                </li>
            </ul>
            <div v-if="noMessage" >暂无未阅读人数!</div>
            <!-- 底部返回上一页 返回首页信息放这里 -->
            <bottom></bottom>
        </div>
    </div>
</template>

<script>
import Bottom from '../bottom.vue'
import default_avatar from '@/assets/images/user.png?20241114'
export default {
    data() {
        return {
            data: [],
            noMessage: false,
            userPic: ''
        }
    },
    components: { Bottom },
    mounted() {
        this.$http.get('/api/mobile/notice/getUnReadUsers',
            {params:
                {
                    noticeId: this.$route.query.id,  
                    userId: this.$route.query.userId
                }
            }
        ).then( res => {
            if(res.data.code == 0) {
                this.data = _.map(res.data.data, val => {
                    this.userPic = val.headUrl || default_avatar;
                    return val;
                })
            } else {
                alert(res.data.message);
            }
        });
    }
}
</script>




// WEBPACK FOOTER //
// src/components/notice/T-notice-unread.vue